import { useEffect, useState } from 'react';

export default function AuthCallbackPage() {
  const [error, setError] = useState('');

  useEffect(() => {
    async function completeSignIn() {
      // Supabase's OAuth flow returns the session directly in the URL hash
      // fragment (#access_token=...&refresh_token=...), not as a ?code=
      // query param — this isn't the authorization-code flow, it's the
      // implicit grant, so there's no server-side exchange step needed.
      const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const accessToken = hashParams.get('access_token');

      if (!accessToken) {
        setError('Missing access token. Please try signing in again.');
        return;
      }

      try {
        localStorage.setItem('sungresh_token', accessToken);
        // Use a full page load rather than client-side navigate() here:
        // navigating immediately after refresh() can race the AuthProvider
        // context update, occasionally bouncing back to /login even with a
        // valid token. A full reload guarantees the app re-mounts and reads
        // the freshly-stored token before any route guard evaluates.
        window.location.href = '/dashboard';
      } catch (err) {
        setError('Google sign-in failed. Please try again.');
      }
    }
    completeSignIn();
  }, []);

  return (
    <div className="auth-wrap">
      <div className="auth-box" style={{ textAlign: 'center' }}>
        <div className="auth-logo" style={{ justifyContent: 'center' }}>
          <div className="auth-logo-mark">S</div>
          <span className="auth-logo-text">SUNGRESH</span>
        </div>
        {error ? (
          <>
            <div className="form-error" style={{ marginTop: 20 }}>{error}</div>
            <a href="/login" className="btn btn-orange" style={{ marginTop: 16, display: 'inline-block' }}>Back to login</a>
          </>
        ) : (
          <div className="auth-sub" style={{ marginTop: 20 }}>Signing you in…</div>
        )}
      </div>
    </div>
  );
}
